import { require200Status } from "../../utils/response.js";
import { BannerConvertSpec } from "../../../types/models/banner.specs.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function bannerEndpoints(builder) {
  return {
    getBanners: builder.query({
      query: ({ query }) => ({
        url: `/member/banner/list${parseQs(query)}`,
        validateStatus: require200Status,
        method: "GET"
      }),
      transformResponse: transformWithSpec(BannerConvertSpec)
    })
  };
}
export {
  bannerEndpoints as default
};
